import { Component, OnInit } from '@angular/core';
import {AuthService} from '../../services/auth.service';
import {FontAwesomeService} from '../../services/font-awesome.service';

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss']
})
export class SidenavComponent implements OnInit {

  constructor(
    private auth: AuthService,
    public faService: FontAwesomeService
  ) { }

  ngOnInit() {
  }
  isAdmin = () => this.auth.isAdmin();
  isUser = () => this.auth.isUser();
  logout = () => this.auth.logout();

}



// WEBPACK FOOTER //
// ./src/app/components/sidenav/sidenav.component.ts